<template>
  <div>
    <p>{{msg.msg}}</p>
    <p class="btnBox">
      <el-button
        type="text"
        @click="test"
      >立即处理</el-button>
    </p>
  </div>
</template>

<script>
export default {
  name: "notifyBtn",
  methods: {
    test() {
      console.log("124");
    },
  },
  props: {
    msg: {
      type: Object,
      default: { a: 1 },
    },
  },
};
</script>

<style lang="scss" scoped>
.btnBox {
  text-align: center;
  line-height: 18px;
  .el-button {
    height: 20px;
  }
}
</style>